// Centralized event names used throughout the app
export const Events = {
    app_open: 'app_open',
    landing_enter: 'landing_enter',
    eula_accepted: 'eula_accepted',
    mode_change: 'mode_change',

    // Study
    study_start: 'study_start',
    study_end: 'study_end',
    card_flip: 'card_flip',
    card_flag_toggle: 'card_flag_toggle',
    review_mode_change: 'review_mode_change',
    deck_scramble: 'deck_scramble',
    tts_start: 'tts_start',
    tts_stop: 'tts_stop',
    generation_live: 'generation_live',
    generation_upload: 'generation_upload',
    generation_foto: 'generation_foto',
    export_pdf: 'export_pdf',
    export_csv: 'export_csv',
    export_anki: 'export_anki',
    listening_start: 'listening_start',
    listening_stop: 'listening_stop',
    foto_capture: 'foto_capture',
    notes_generate: 'notes_generate',

    // Game
    game_start: 'game_start',
    game_end: 'game_end',

    // Exam
    exam_start: 'exam_start',
    exam_begin: 'exam_begin',
    exam_complete: 'exam_complete',
    exam_created: 'exam_created',
    exam_save: 'exam_save',
    exam_flagged_folder_create: 'exam_flagged_folder_create',
    exam_retake: 'exam_retake',

    // Paywall
    paywall_view: 'paywall_view',
    paywall_dismissed: 'paywall_dismissed',
    pricing_section_view: 'pricing_section_view',

    // PWA install
    pwa_install_banner_shown: 'pwa_install_banner_shown',
    pwa_install_banner_dismissed: 'pwa_install_banner_dismissed',
    pwa_install_clicked: 'pwa_install_clicked',
    pwa_install_accepted: 'pwa_install_accepted',
    pwa_install_declined: 'pwa_install_declined',
    pwa_ios_banner_shown: 'pwa_ios_banner_shown',
    pwa_ios_banner_dismissed: 'pwa_ios_banner_dismissed'
};